class CookieController {
  constructor() {
    this.SSRCookies = {};
  }

  getABCookieById(testId) {
    if (!testId) {
      return false;
    }

    let ABCookie;

    if (typeof document === 'undefined') {
      ABCookie = this.SSRCookies[`ab_test_involved_${testId}`] ?? 0;
    } else {
      const [, data] = document.cookie.match(new RegExp(`ab_test_involved_${testId}=([^;]+)`)) ?? [false, 0];
      ABCookie = data;
    }

    if (!ABCookie) {
      return false;
    }

    return Number(ABCookie);
  }

  setSSRCookies(cookies) {
    this.SSRCookies = cookies;
  }

  // eslint-disable-next-line class-methods-use-this
  transferSSRCookies({ headers, setCookie, ssrCookies }) {
    const rawCookies = headers['set-cookie'];

    for (let i = 0; i < rawCookies.length; i++) {
      if (rawCookies[i].includes('ab_test_involved_')) {
        const cookieParts = headers['set-cookie'][i].split('; ');
        const [name, value] = cookieParts[0].split('=');

        setCookie[name] = {
          value,
          options: { maxAge: cookieParts[2].split('=')[1], httpOnly: false },
        };

        ssrCookies[name] = value;
      }
    }
  }
}

export default new CookieController();
